//Object difference
const deepDiffMapper = function deepDiffMapper(obj1, obj2) {
  if (isFunction(obj1) || isFunction(obj2)) {
    throw 'Invalid argument. Function given, object expected.'
  }
  if (isValue(obj1) || isValue(obj2)) {
    return {
      type: compareValues(obj1, obj2),
      data: obj1 === undefined ? obj2 : obj1,
    }
  }

  let diff = {}
  for (const key in obj1) {
    if (isFunction(obj1[key])) {
      continue
    }

    let value2 = undefined
    if (obj2[key] !== undefined) {
      value2 = obj2[key]
    }

    diff[key] = deepDiffMapper(obj1[key], value2)
  }
  for (const key in obj2) {
    if (isFunction(obj2[key]) || diff[key] !== undefined) {
      continue
    }

    diff[key] = deepDiffMapper(undefined, obj2[key])
  }

  const ret = {}
  ret.result = diff
  ret.filterByType = filterByType
  return ret
}

function filterByType(type, obj) {
  const checkType = (objType, requestedType) => {
    if (requestedType !== VALUE_CHANGED) {
      return objType === requestedType
    } else {
      return [VALUE_UPDATED, VALUE_DELETED, VALUE_CREATED].includes(objType)
    }
  }
  let parse
  if (obj !== undefined) {
    parse = obj.result
  } else {
    parse = JSON.parse(JSON.stringify(this.result))
  }
  for (const key in parse) {
    if (parse[key].type === undefined) {
      filterByType(type, parse[key])
      if (Object.keys(parse[key].result).length === 0) {
        delete parse[key]
      }
    } else if (!checkType(parse[key].type, type)) {
      delete parse[key]
    }
  }
  const ret = {}
  ret.result = parse
  ret.filterType = filterByType
  return ret
}

const VALUE_CREATED = 'created'
const VALUE_UPDATED = 'updated'
const VALUE_DELETED = 'deleted'
const VALUE_CHANGED = 'changed'
const VALUE_UNCHANGED = 'unchanged'

export { VALUE_CREATED, VALUE_UPDATED, VALUE_DELETED, VALUE_CHANGED, VALUE_UNCHANGED, deepDiffMapper }

function isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]'
}

function isArray(x) {
  return Object.prototype.toString.call(x) === '[object Array]'
}

function isDate(x) {
  return Object.prototype.toString.call(x) === '[object Date]'
}
function isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]'
}
function isValue(x) {
  return !isObject(x) && !isArray(x)
}
function compareValues(value1, value2) {
  if (!isNaN(value1 && !isNaN(value2))) {
    if (parseFloat(value1) === parseFloat(value2)) {
      return VALUE_UNCHANGED
    }
  }
  if (value1 === value2) {
    return VALUE_UNCHANGED
  }
  if (isDate(value1) && isDate(value2) && value1.getTime() === value2.getTime()) {
    return VALUE_UNCHANGED
  }
  if (value1 === undefined) {
    return VALUE_CREATED
  }
  if (value2 === undefined) {
    return VALUE_DELETED
  }
  return VALUE_UPDATED
}

export function getObjectDeepDiff(obj1, obj2) {
  let diff = deepDiffMapper(obj1, obj2)

  const created = diff.filterByType(VALUE_CREATED).result
  const updated = diff.filterByType(VALUE_UPDATED).result
  const deleted = diff.filterByType(VALUE_DELETED).result
  const changed = diff.filterByType(VALUE_CHANGED).result
  const unchanged = diff.filterByType(VALUE_UNCHANGED).result
  const conditions = [created, updated, deleted, changed]

  let result = []
  conditions.forEach((c) => {
    if (Object.keys(c).length > 0) {
      result.push(c)
    }
  })
  return result
}
